import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Ban: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['path', { d: 'm4.9 4.9 14.2 14.2' }],
  ],
];

export default Ban;
